import AdminRoutes from "../components/adminFolders/adminRoutes/AdminRoutes";

const AdminPage = () => {
    return ( 
        <div>
            <h1>Admin Page</h1>
            <AdminRoutes />
        </div>
        
     );
}
 
export default AdminPage;